export const MAX_DISPLAY_PAGE_NUMBER = 10
export const NUMBER_ITEM_PER_PAGE = 40
export const DEFAULT_SORT_ORDER = 'sku_asc'
export const PRINTING_METHOD_ALL = 'all'
export const PRINTING_METHOD_FULL = 'full'
export const PRINTING_METHOD_SINGLE = 'single'
export const FACET_TYPE: { [key: string] : string} = {
  CHECK_BOX: 'checkbox',
  IMAGE: 'image'
}
export const FACET_INDIVIDUAL = 'individual_page'
export const ALL_CATEGORIES = 'All Categories'
export const PRODUCT_CATEGORY = 'Product Category'
export const RAKSUL_TITLE = 'CUSTA Online Printing'

export const PRINTING_METHOD = [
  {
    value: 'full',
    label: 'Full Color Printing'
  },
  {
    value: 'single',
    label: 'Single Color Printing'
  }
]

export const SORT_ORDER = [
  {
    value: 'sku_asc',
    label: 'Recommended / Standard'
  },
  {
    value: 'unit_price_asc',
    label: 'Lowest Unit Price'
  },
  {
    value: 'unit_price_desc',
    label: 'Highest Unit Price'
  },
  {
    value: 'min_quantity_asc',
    label: 'Minimum Lot Order'
  },
  {
    value: 'delivery_date_asc',
    label: 'Earliest Delivery Date'
  }
]

export const PRINT_METHODS = {
  full: 'Full Color Printing',
  single: 'Single Color Printing'
}

export const FACET_QUERY_PREFIX = 'f_'
